// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20hzo","content":"styles_content__jsZ_u"};